import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { ChannelDescriptionService, ChannelDescription } from './channel-description.service';
import { LoadingMaskService } from '../../../shared/loading-mask/loading-mask.service';
import { CommonFiltersResolve } from '../filters/common-filters-resolve';
import { ActiveFiltersService } from '../filters/active-filters.service';

@Injectable()
export class ChannelDescriptionResolve extends CommonFiltersResolve implements Resolve<ChannelDescription[]> {
	constructor(private service: ChannelDescriptionService,
	            private activeFiltersService: ActiveFiltersService,
	            private mask: LoadingMaskService) {
		super(activeFiltersService);
	}

	resolve(route: ActivatedRouteSnapshot): Promise<ChannelDescription[]> {
		this.mask.addLoading();
		let filters: any = this.initActiveFiltersFromURLParams(route);
		return this.service.getChannelDescriptions(filters)
			.then((orders: ChannelDescription[]) => {
				this.mask.removeLoading();
				return orders;
			});
	}
}
